import { useTranslation } from 'react-i18next';
import { ShieldAlert } from 'lucide-react';
import { Page, PageContent } from '@bliks-io/ui';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/**
 * Shown when a member has no reachable landing page — chiefly external members
 * without an elevated role, who legitimately lack Dashboard access. Without
 * this, the guard falls through to DashboardPage and its 403 surfaces as a raw
 * error screen. This is an honest "no access yet" surface, not an error.
 */
export function NoDashboardAccess() {
  const { t } = useTranslation();
  useDocumentTitle('pageTitles.home');

  return (
    <Page>
      <PageContent>
        <div className="flex min-h-[400px] flex-col items-center justify-center gap-4 text-center">
          <ShieldAlert className="h-12 w-12 text-muted-foreground" strokeWidth={1.5} />
          <div className="space-y-1">
            <h1 className="text-xl font-semibold">{t('noDashboardAccess.title')}</h1>
            <p className="max-w-md text-sm text-muted-foreground">
              {t('noDashboardAccess.description')}
            </p>
          </div>
        </div>
      </PageContent>
    </Page>
  );
}
